enum AnalyticsEventKey {
    Login = "user_logged_in",
    Register = "user_registered",
    CodeActived = "code_activated",
}

export default AnalyticsEventKey;
